import SharePageV3 from './SharePage.v3'

export default SharePageV3
// eslint-disable-next-line import/export
export * from './SharePage.v3'
